import type { ComponentType } from 'react';
import {
  BuildingOfficeIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ClockIcon,
  HandRaisedIcon,
  ShieldExclamationIcon,
  Square3Stack3DIcon,
  Squares2X2Icon,
  UserGroupIcon,
  WrenchIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import type { AllocationBucketType, AllocationType } from '@/features/Collaborators/Models';
import { AllocationBucketTypes, AllocationTypes } from '@/features/Collaborators/Models';

export const ALLOCATION_TYPE_ICON_MAP: Record<
  AllocationType,
  ComponentType<{ className?: string }>
> = {
  [AllocationTypes.BodyShop]: HandRaisedIcon,
  [AllocationTypes.OpenScope]: Square3Stack3DIcon,
  [AllocationTypes.ClosedScope]: BriefcaseIcon,
  [AllocationTypes.Absence]: ClockIcon,
  [AllocationTypes.Operational]: WrenchIcon,
  [AllocationTypes.Commercial]: BuildingOfficeIcon,
  [AllocationTypes.Support]: UserGroupIcon,
  [AllocationTypes.Product]: ShieldExclamationIcon,
  [AllocationTypes.Provisional]: UserIcon,
};

export const ALLOCATION_BUCKET_ICON_MAP: Record<
  AllocationBucketType,
  ComponentType<{ className?: string }>
> = {
  [AllocationBucketTypes.Defined]: ChartBarIcon,
  [AllocationBucketTypes.Daily]: CalendarDaysIcon,
  [AllocationBucketTypes.Weekly]: CalendarDaysIcon,
  [AllocationBucketTypes.Monthly]: Squares2X2Icon,
};
